<template>
    <button
        role="button"
        type="button"
        class="button expand-collapse"
        :aria-label="[ flipUp ? 'Collapse' : 'Expand' ]"
    >
        <MaterialDesignIcon
            :class="{ 'rotate-icon': flipUp }"
            className="chevron-down"
            pxSize="24"
        />
    </button>
</template>

<script>
// Components
import MaterialDesignIcon from '@/components/base/MaterialDesignIcon';

export default {
    name: 'ButtonChevronFlippable',
    components: {
        MaterialDesignIcon,
    },
    props: {
        flipUp: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
};
</script>

<style scoped lang="scss">
.expand-collapse {
    background-color: #eeeeee;
    border-color: #eeeeee;
    padding-top: 0;
}
.rotate-icon {
    transform: rotate( 180deg );
}
</style>
